import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import styles from './PlaceholderPages.module.scss';
import { useDispatch } from "react-redux";
import { logout } from "../features/authentication/authenticationSlice"; 
import { useHistory } from 'react-router-dom';

const LogoutButton = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const handleLogout = () => {
        dispatch(logout());
        history.push("/login");
    };

    return (
        <div className={styles['logout-button-container']}>
            <Button
                variant="danger"
                className={styles['logout-button']}
                onClick={handleLogout}
            >
                Logout
            </Button>
        </div>
    );
};

export const NotificationPage = () => {
    // This is now a placeholder - the actual implementation is in features/notifications/NotificationPage.js
    // Keeping this for backward compatibility
    return null;
};

export const ProfilePage = () => {
    return (
        <div className={styles['profile-page-wrapper']}>
            <LogoutButton />
            <Container fluid className={styles['placeholder-container']}>
                <Row>
                    <Col>
                        <Card className={styles['placeholder-card']}>
                            <Card.Header className={styles['card-header']}>
                                <h3>User Profile</h3>
                            </Card.Header>
                            <Card.Body className={styles['card-body']}>
                                <p>The user profile is currently available on the Admin Panel. Please contact the administrator if you need any changes.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
